import { current } from '@reduxjs/toolkit'
import { api as revisionApi } from './auto-generated/revision'

revisionApi.enhanceEndpoints({
  endpoints: {
    revisionDeleteFeedback: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        let patchResult
        try {
          const { data } = await queryFulfilled
          patchResult = dispatch(
            revisionApi.util.updateQueryData(
              'revisionGetRecording',
              { id: data.recording_id.toString() },
              (draft) => {
                const updatedChunks = draft.chunks.map((chunk) => {
                  if (chunk.comments.some((comment) => comment.id === args.id)) {
                    const updatedComments = chunk.comments.filter(
                      (comment) => comment.id !== args.id,
                    )
                    return { ...chunk, comments: updatedComments }
                  }
                  return chunk
                })
                return { ...draft, chunks: updatedChunks }
              },
            ),
          )
        } catch {
          patchResult?.undo()
        }
      },
    },
    // revisionAddUserPreferenceOnFeedback: {
    //   async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
    //     let patchResult
    //     try {
    //       const { data } = await queryFulfilled
    //       patchResult = dispatch(
    //         revisionApi.util.updateQueryData(
    //           'revisionGetRecording',
    //           { id: data.recording_id.toString() },
    //           (draft) => {
    //             const { user } = (getState() as RootState).auth
    //             const updatedChunks = draft.chunks.map((chunk) => {
    //               if (chunk.comments.some((comment) => comment.id === data?.feedback_id)) {
    //                 return {
    //                   ...chunk,
    //                   comments: chunk.comments.map((comment) => {
    //                     if (comment.id === args.id) {
    //                       console.log("preference : ", data.preference)
    //                       return data.preference
    //                         ? {
    //                             ...comment,
    //                             dislikes: { ...comment.dislikes, user_ids: [] },
    //                             likes: {
    //                               ...comment.likes,
    //                               user_ids: [...comment.likes.user_ids, user.id],
    //                             },
    //                           }
    //                         : {
    //                             ...comment,
    //                             dislikes: {
    //                               ...comment.dislikes,
    //                               user_ids: [...comment.dislikes.user_ids, user.id],
    //                             },
    //                             likes: { ...comment.likes, user_ids: [] },
    //                           }
    //                     }
    //                     return comment
    //                   }),
    //                 }
    //               }
    //               return chunk
    //             })
    //             draft.chunks = updatedChunks
    //             return draft
    //           },
    //         ),
    //       )
    //     } catch {
    //       patchResult?.undo()
    //     }
    //   },
    // },
    revisionCreateTeacherFeedback: {
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        let patchResult
        try {
          const { data: newComment } = await queryFulfilled
          patchResult = dispatch(
            revisionApi.util.updateQueryData(
              'revisionGetRecording',
              { id: args.createFeedbackRequest.recording_id },
              (draft) => {
                const { user } = (getState() as RootState).auth
                const startTime = args.createFeedbackRequest.start_time
                const endTime = args.createFeedbackRequest.end_time
                const chunkIsExist = draft.chunks.some(
                  (chunk) => chunk.start_time === startTime && chunk.end_time === endTime,
                )
                let updatedChunks
                chunkIsExist
                  ? (updatedChunks = draft.chunks.map((chunk) => {
                      if (chunk.start_time === startTime && chunk.end_time === endTime) {
                        return {
                          ...chunk,
                          comments: [
                            ...chunk.comments,
                            {
                              id: newComment.id,
                              is_ai: false,
                              comment: args.createFeedbackRequest.comment,
                              dislikes: { count: 0, user_ids: [] },
                              created_at: newComment.created_at,
                              likes: { count: 0, user_ids: [] },
                              user: {
                                avatar: user?.image,
                                full_name: user?.full_name,
                                id: user?.id,
                              },
                            },
                          ],
                        }
                      }
                      return chunk
                    }))
                  : (updatedChunks = [
                      ...draft.chunks,
                      {
                        created_at: newComment.created_at,
                        end_time: endTime,
                        start_time: startTime,
                        comments: [
                          {
                            id: newComment.id,
                            is_ai: false,
                            comment: args.createFeedbackRequest.comment,
                            dislikes: { count: 0, user_ids: [] },
                            created_at: newComment.created_at,
                            likes: { count: 0, user_ids: [] },
                            user: {
                              avatar: user?.image,
                              full_name: user?.full_name,
                              id: user?.user_id,
                            },
                          },
                        ],
                      },
                    ])
                draft.chunks = updatedChunks
                return draft
              },
            ),
          )
        } catch {
          patchResult?.undo()
        }
      },
    },
    revisionCreateAudioTeacherFeedback: {
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        try {
          const { data: newFeedback } = await queryFulfilled
          patchResult = dispatch(
            revisionApi.util.updateQueryData(
              'revisionGetRecording',
              {
                id: args.bodyCreateAudioTeacherFeedbackApiV1ExtensionsRevisionAudioFeedbackPost.get(
                  'recording_id',
                ),
              },
              (draft) => {
                const { user } = (getState() as RootState).auth
                const startTime = parseFloat(
                  args.bodyCreateAudioTeacherFeedbackApiV1ExtensionsRevisionAudioFeedbackPost.get(
                    'start_time',
                  ),
                )
                const endTime = parseFloat(
                  args.bodyCreateAudioTeacherFeedbackApiV1ExtensionsRevisionAudioFeedbackPost.get(
                    'end_time',
                  ),
                )
                const chunkIsExist = draft.chunks.some(
                  (chunk) => chunk.start_time === startTime && chunk.end_time === endTime,
                )

                let updatedChunks
                chunkIsExist
                  ? (updatedChunks = draft.chunks.map((chunk) => {
                      if (chunk.start_time === startTime && chunk.end_time === endTime) {
                        return {
                          ...chunk,
                          comments: [
                            ...chunk.comments,
                            {
                              id: newFeedback.id,
                              is_ai: false,
                              audio_comment_url: newFeedback.audio_comment_url,
                              dislikes: { count: 0, user_ids: [] },
                              created_at: newFeedback.created_at,
                              likes: { count: 0, user_ids: [] },
                              user: {
                                avatar: user?.image,
                                full_name: user?.full_name,
                                id: newFeedback.user_id,
                              },
                            },
                          ],
                        }
                      }
                      return chunk
                    }))
                  : (updatedChunks = [
                      ...draft.chunks,
                      {
                        created_at: newFeedback.created_at,
                        end_time: endTime,
                        start_time: startTime,
                        comments: [
                          {
                            id: newFeedback.id,
                            is_ai: false,
                            audio_comment_url: newFeedback.audio_comment_url,
                            dislikes: { count: 0, user_ids: [] },
                            created_at: newFeedback.created_at,
                            likes: { count: 0, user_ids: [] },
                            user: {
                              avatar: user?.image,
                              full_name: user?.full_name,
                              id: newFeedback.user_id,
                            },
                          },
                        ],
                      },
                    ])
                draft.chunks = updatedChunks
                return draft
              },
            ),
          )
        } catch {
          patchResult?.undo()
        }
      },
    },
    // revisionDeleteRecording: {
    //   async onQueryStarted(args, { dispatch, queryFulfilled }) {
    //     let patchResult
    //     try {
    //       await queryFulfilled
    //       patchResult = dispatch(
    //         revisionApi.util.updateQueryData(
    //           'revisionListRecordings',
    //           { testMyself: false },
    //           (draftRecordings) => {
    //             return draftRecordings?.filter((item) => item?.id !== args?.id)
    //           },
    //         ),
    //       )
    //     } catch {
    //       patchResult?.undo()
    //     }
    //   },
    // },
  },
})

export { revisionApi }
